// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Tooltip } from "antd";
import DateFormat from "../../utils/DateFormat";

const customTooltipDelay = 0.05;

export class CustomTooltip extends React.PureComponent<{ data: string }> {
  render() {
    const { data } = this.props;
    return (
      <Tooltip
        mouseEnterDelay={customTooltipDelay}
        mouseLeaveDelay={customTooltipDelay}
        placement="topLeft"
        title={data}
        style={{
          width: "50%"
        }}
      >
        <span className="ellipsis-span">{data}</span>
      </Tooltip>
    );
  }
}

export const tooltipRender = (data: string) => {
  return <CustomTooltip data={data} />;
};

export const tooltipDateRender = (date?: Date) => {
  const data: string = date ? DateFormat.standardDate(date) : "";
  return <CustomTooltip data={data} />;
};
